import {UPDATE_NOTIFICATION_START} from "../../types";

export const update_notification = (payload) => ({
    type: UPDATE_NOTIFICATION_START,
    payload,
});
